module.exports = __webpack_public_path__ + "img/grshield.5b064660.png";